// OurServices.jsx

import React from 'react';
import './ourservices.css';
import { Link } from 'react-router-dom';

// Importing product icons
import csIcon from '../../assets/icons/cs.png';
import fundreachIcon from '../../assets/icons/fundreach.png';
import mastakashIcon from '../../assets/icons/mastakash.png';
import chamaflowIcon from '../../assets/icons/chamaflow.png';

const products = [
  {
    title: 'CS Church Management Software',
    description: 'Manage church activities, finances, memberships, and contributions seamlessly.',
    icon: csIcon,
    url: 'https://cs.roshtech.co.ke',
  },
  {
    title: 'FundReach Fundraising Platform',
    description: 'Secure and transparent social fundraising tailored for African communities.',
    icon: fundreachIcon,
    url: 'https://fundreach.co.ke',
  },
  {
    title: 'MastaKash',
    description: 'Simplify financial management for Chamas and individuals with savings, loans, and secure transfers.',
    icon: mastakashIcon,
    url: 'https://mastakash.com',
  },
  {
    title: 'ChamaFlow',
    description: 'Desktop app for managing Chamas and micro-finances, tailored for small businesses in Africa.',
    icon: chamaflowIcon,
    url: '#', // Update with actual URL when available
  },
 
];

const OurServices = () => {
  return (
    <section className="our-services" id="products">
      <h2 className="section-title">
        <span className="highlight">Our</span> Products
      </h2>
      <p className="section-subtitle">
        We develop intelligent, user-centered software solutions across web, mobile, and desktop platforms, addressing diverse industry needs.
      </p>
      <div className="products-grid">
        {products.map((product, index) => (
          <div className="product-card" key={index}>
            <img src={product.icon} alt={`${product.title} icon`} className="product-icon" />
            <h3 className="product-title">{product.title}</h3>
            <p className="product-description">{product.description}</p>
            {product.url && (
              <a href={product.url} target="_blank" rel="noopener noreferrer" className="learn-more-button">
                Learn More
              </a>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default OurServices;
